/* eslint-disable import/no-anonymous-default-export */
import request from '@hho-middle/network'

export default {
  // 用户登录 获取动态路由
  getAsyncMenu: () => request('/menu/getMenu').post(),
  // 微应用列表
  getMicroApps: () => request('/sysDictionary/findSysDictionary?type=microApps').get()
}
